import { render, staticRenderFns } from "./ListarDocumentosHeaderBotoesBarra.vue?vue&type=template&id=2a0ef81f&scoped=true"
import script from "./ListarDocumentosHeaderBotoesBarra.vue?vue&type=script&lang=js"
export * from "./ListarDocumentosHeaderBotoesBarra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ef81f",
  null
  
)

export default component.exports